import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { ProductOrderService } from "../../../service/ProductOrderService";
import Toast from 'light-toast';

class RecalculateOrdersServiceCostStore {

    public productOrdersIds: string[];
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, productOrdersIds: string[]) {
        this.productOrdersIds = productOrdersIds;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }


    @action
    public async recalculate() {
        const response = await ProductOrderService.recalculateServiceCost(this.productOrdersIds);
        if (!response.success && response.status === 400 && response.error === 'ERROR_00_400_0003') {
            await this.commonStore.showErrorToast('No se pudo recalcular uno o más envíos');
        } else {
            this.commonStore.processErrors(response);
        }
        Toast.success('Costos recalculados con suceso!!!', 3000);
        return response.success;
    }
}

export default RecalculateOrdersServiceCostStore;